"use-strict";

export default (obj, props) => {
  const newObj = {};
  for (const prop of props) newObj[prop] = obj[prop];
  return newObj;
};
